var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGleapBotIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_72_4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_72_4",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 0H0V72H72V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_72_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "botbg",
    d: "M72 0H0V72H72V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "botclip",
    d: "M19 45.0851H30.0638L31.3404 52.3192L21.6646 55.9893C20.3776 56.4775 19 55.5267 19 54.1502V45.0851Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "botclip",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4521 17H48.4415C51.4526 17 53.8936 19.4545 53.8936 22.4823V47.0486C53.8936 50.0764 51.4526 52.5309 48.4415 52.5309H24.4521C21.441 52.5309 19 50.0764 19 47.0486V22.4823C19 19.4545 21.441 17 24.4521 17ZM46.379 39.8651C46.4758 39.3377 46.0607 38.8682 45.575 38.9765C42.3299 39.6989 31.4952 39.7232 28.2062 38.9945C27.7082 38.884 27.2792 39.3637 27.3811 39.9034C28.1358 43.905 32.0996 46.9565 36.8765 46.9565C41.6687 46.9565 45.6423 43.8853 46.379 39.8651ZM46.2393 25.4027C46.2393 24.2273 45.2918 23.2745 44.1229 23.2745C42.954 23.2745 42.0065 24.2273 42.0065 25.4027V31.7871C42.0065 32.9624 42.954 33.9152 44.1229 33.9152C45.2918 33.9152 46.2393 32.9624 46.2393 31.7871V25.4027ZM29.4575 23.2745C30.6127 23.2745 31.5491 24.2161 31.5491 25.3776V31.6869C31.5491 32.8484 30.6127 33.7899 29.4575 33.7899C28.3024 33.7899 27.366 32.8484 27.366 31.6869V25.3776C27.366 24.2161 28.3024 23.2745 29.4575 23.2745Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGleapBotIcon);
export default __webpack_public_path__ + "static/media/GleapBotIcon.08912425ef515737902a1619f5f78af7.svg";
export { ForwardRef as ReactComponent };